export function noticeIsShow(payload) {
  return {
    type: 'NOTICE_SHOW',
    payload: payload,
  };
}

export default function noticePopInfo(state = { noticeShow: false }, action) {
  const { type, payload } = action;

  switch (type) {
    case 'NOTICE_SHOW':
      return Object.assign({}, state, { noticeShow: payload });
    default:
      return state;
  }
}
